import { render, staticRenderFns } from "./NewPayroll.vue?vue&type=template&id=319d8d9c&scoped=true&"
import script from "./NewPayroll.vue?vue&type=script&lang=js&"
export * from "./NewPayroll.vue?vue&type=script&lang=js&"
import style0 from "./NewPayroll.vue?vue&type=style&index=0&id=319d8d9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319d8d9c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/elopez/repos/FacturaIzzi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('319d8d9c')) {
      api.createRecord('319d8d9c', component.options)
    } else {
      api.reload('319d8d9c', component.options)
    }
    module.hot.accept("./NewPayroll.vue?vue&type=template&id=319d8d9c&scoped=true&", function () {
      api.rerender('319d8d9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Admin/Payrolls/NewPayroll.vue"
export default component.exports